<template>
  <v-card
    class="rounded-xl ma-2 pa-5"
    max-width="1150px"
  >
    <v-card flat>
      <v-card-title>
        <v-icon
          color="ppc_darkgreen"
          class="mr-2"
        >
          $vuetify.icons.icon_mdi_calendar
        </v-icon>
        Allowed Days
      </v-card-title>

      <v-card-subtitle>
        Starting
      </v-card-subtitle>

      <v-card-text class="d-flex flex-row flex-wrap">
        <v-card
          v-for="(startDay, i) in week"
          :key="i"
          flat
          width="150px"
        >
          <v-checkbox
            :label="`${startDay}`"
            :input-value="getStartDay(startDay)"
            :disabled="$store.getters.loadingApp === 1"
            @change="$emit('change-start-days', $event, startDay)"
          />
        </v-card>
      </v-card-text>

      <v-divider />
    </v-card>

    <v-card flat>
      <v-card-subtitle>
        Ending
      </v-card-subtitle>

      <v-card-text class="d-flex flex-row flex-wrap">
        <v-card
          v-for="(endDay, i) in week"
          :key="i"
          flat
          width="150px"
        >
          <v-checkbox
            :label="`${endDay}`"
            :input-value="getEndDay(endDay) === true"
            :disabled="$store.getters.loadingApp === 1"
            @change="$emit('change-end-days', $event, endDay)"
          />
        </v-card>
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
export default {
  name: 'ServiceAllowedDays',

  props: {

    week: {
      type: Array,
      default: () => [],
    },

    getStartDay: {
      type: Function,
      required: true,
    },

    getEndDay: {
      type: Function,
      required: true,
    },
    
  },
}
</script>